<div class="kt-portlet__foot">
	<div class="kt-form__actions">
		<ng-content></ng-content>
	</div>
</div>
